import { render } from "./ObjectsComponent.vue?vue&type=template&id=3e287bb9&scoped=true"
import script from "./ObjectsComponent.vue?vue&type=script&lang=js"
export * from "./ObjectsComponent.vue?vue&type=script&lang=js"

import "./ObjectsComponent.vue?vue&type=style&index=0&id=3e287bb9&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e287bb9"]])

export default __exports__